import React from "react";

import { SupTxStatus } from "../TxStatus";
import type { TxValueProps } from "../types";

import { HashValue } from "./components/HashValue";
import { VaultValue } from "./components/VaultValue";
import { AddressValue } from "./components/AddressValue";
import { ServiceValue } from "./components/ServiceValue";
import { StatusServiceValue } from "./components/StatusServiceValue";
import { TokenValue } from "./components/TokenValue";
import { ReceivedTokenValue } from "./components/ReceivedTokenValue";
import { Value } from "./components/Value";

export function SupTxValue({ component, props }: TxValueProps) {
  switch (component) {
    case "hash":
      return <HashValue {...props} />;
    case "vault":
      return <VaultValue {...props} />;
    case "address":
      return <AddressValue {...props} />;
    case "service":
      return <ServiceValue {...props} />;
    case "status-service":
      return <StatusServiceValue {...props} />;
    case "status-value":
      return <SupTxStatus value={props.status} />;
    case "token":
      return <TokenValue {...props} />;
    case "received-token":
      return <ReceivedTokenValue {...props} />;
    case "value":
      return <Value {...props} />;
    default:
      return null;
  }
}
